import { adminControlResultURL, adminControlURL } from '../../../NonReact/constants/ApiConstants'
import { RESTMethods } from '../../../NonReact/constants/REST'
import { AdminAction } from '../../../ReactRouting/Components/Organisms/AdminControl/Types'
import { requestJSONAsync } from './AsyncFetching'

export type AdminControlRequest = {
    PartitionId: number
    TelsysId: number
    Action: AdminAction
    Data: Record<string, string>
}

export type AdminControlResponse = {
    message: string
}

export const adminControlRequestAsync = (request: AdminControlRequest): Promise<Nullable<AdminControlResponse>> =>
    requestJSONAsync<AdminControlResponse>(adminControlURL, adminControlResultURL, {
        method: RESTMethods.POST,
        body: request
    })
